// extracted by mini-css-extract-plugin
export default {"container":"E4Iy0oMx","svg":"LEQFosfb","path":"ydbxxSDu"};